// Canonical clinical categories used by the disease library and article tags.
// Stored content has drifted over time (singular vs plural, British vs American
// spelling, older short names like "Cardiovascular"), so matching goes through
// normalizeCategory rather than comparing raw strings.

export const DISEASE_CATEGORIES = [
  { id: 'cardio', name: 'Cardiovascular diseases' },
  { id: 'neonatal', name: 'Neonatal diseases' },
  { id: 'vascular', name: 'Vascular diseases' },
  { id: 'respiratory', name: 'Respiratory diseases' },
  { id: 'neuro', name: 'Neurological diseases' },
  { id: 'gi', name: 'Gastrointestinal diseases' },
  { id: 'liver', name: 'Liver diseases' },
  { id: 'endocrine', name: 'Endocrine diseases' },
  { id: 'renal', name: 'Kidney diseases' },
  { id: 'hema', name: 'Haematological diseases' },
  { id: 'musculo', name: 'Musculoskeletal diseases' },
  { id: 'infect', name: 'Infectious diseases' },
  { id: 'derm', name: 'Dermatological diseases' },
  { id: 'obs', name: 'Obstetric conditions' },
  { id: 'gyne', name: 'Gynaecological diseases' },
  { id: 'psych', name: 'Psychiatric disorders' },
  { id: 'ophthal', name: 'Ophthalmological diseases' },
  { id: 'ent', name: 'ENT diseases' },
  { id: 'cancer', name: 'Cancer and tumours' },
  { id: 'critical', name: 'Critical care conditions' },
];

export const CATEGORY_NAMES = DISEASE_CATEGORIES.map(c => c.name);

// Words that carry no distinguishing meaning, so "Cardiovascular",
// "Cardiovascular disease" and "Cardiovascular diseases" all collapse together.
const GENERIC_WORDS = new Set(['disease', 'disorder', 'condition']);

export const normalizeCategory = (value) => (value || '')
  .toString()
  .toLowerCase()
  .replace(/ae/g, 'e')    // haematological -> hematological
  .replace(/oe/g, 'e')    // oesophageal -> esophageal
  .replace(/our/g, 'or')  // tumours -> tumors
  .split(/[^a-z0-9]+/)
  .filter(Boolean)
  .map(word => word.replace(/s$/, ''))
  .filter(word => word && !GENERIC_WORDS.has(word))
  .join(' ');

export const categoriesMatch = (a, b) => {
  const left = normalizeCategory(a);
  return !!left && left === normalizeCategory(b);
};

// A disease may carry several categories. Newer records use `categories`;
// older ones only have a single `category`, so read through both.
export const getCategories = (item) => {
  const many = Array.isArray(item?.categories) ? item.categories : [];
  const all = many.length ? many : [item?.category];
  const seen = new Set();
  return all
    .map(value => (value || '').toString().trim())
    .filter(value => {
      const key = normalizeCategory(value);
      if (!key || seen.has(key)) return false;
      seen.add(key);
      return true;
    });
};
